import React, { FC, ReactElement, ReactNode } from 'react'
import { Link } from 'react-router-dom'
import { isStringNotEmpty } from '../../../../NonReact/utils/GlobalFunctions'

type Props = {
    children: ReactNode
    className?: string
    to?: string
    href?: string
    title?: string
    disabled?: boolean
}

export const RouterAnchor: FC<Props> = ({
    children,
    className,
    to,
    href,
    title,
    disabled = false
}: Props): ReactElement => {
    if (disabled) {
        return <span className={`${className} anchor anchor-disabled`}>{children}</span>
    }

    return isStringNotEmpty(to) ? (
        <Link to={to} title={title} className={`${className} anchor`}>
            {children}
        </Link>
    ) : (
        <a href={href} title={title} className={`${className} anchor`}>
            {children}
        </a>
    )
}
